import Swiper from 'swiper';
import { Autoplay, FreeMode } from 'swiper/modules';

export default function logosShowcaseBlock() {
	const els = document.querySelectorAll('[data-js="logos-swiper"]');
	if (!els.length) return;

	els.forEach((el) => {
		if (el.swiper) return;

		const wrapper = el.querySelector('.swiper-wrapper');
		const slidesCount = wrapper?.children?.length || 0;

		if (wrapper && slidesCount > 0 && slidesCount < 10) {
			wrapper.innerHTML += wrapper.innerHTML;
			wrapper.innerHTML += wrapper.innerHTML;
		}

		new Swiper(el, {
			modules: [Autoplay, FreeMode],
			slidesPerView: 'auto',
			loop: true,
			loopAdditionalSlides: 20,
			speed: 8000,
			freeMode: {
				enabled: true,
				momentum: false,
			},
			autoplay: {
				delay: 0,
				disableOnInteraction: false,
				pauseOnMouseEnter: false,
			},
			allowTouchMove: false,
			simulateTouch: false,
			spaceBetween: 90,

			breakpoints: {
				0: {
					spaceBetween: 70,
				},
				768: {
					spaceBetween: 90,
				},
			},
		});
	});
}
